<template>
  <div class="new-main-footer-revamp__item__child">
    <div class="new-main-footer-revamp__item__child__wrapper">
      <div class="new-main-footer-revamp__item__child__title">
        Promo & tips
      </div>
      <div
        v-if="promotips.length > 0"
        class="sitemap"
      >
        <router-link
          v-for="nav in promotips"
          :key="nav.title"
          name="spanServices"
          :to="nav.link"
        >
          {{ nav.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromoTipsFooter",
  data() {
    return {
      promotips: [
        {
          title: "Promo terbaru",
          link: "/promo",
        },
        {
          title: "Info Seller",
          link: "/info-seller",
        },
        {
          title: "Info Mitra",
          link: "/info-mitra",
        },
      ],
    }
  },
  methods: {
    onClick(url) {
      if(url) {
        return this.$router.push(url)
      }
    }
  }
}
</script>
